<template>
	<transition name="modal">
		<div class="modal-mask">
		<div class="modal-wrapper" @click="$emit('closeModal')">
			<div class="row">
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
			<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
				<div class="modal-container" @click.stop>

				<div class="modal-header row" style="justify-content: flex-end;">
					<!-- <div class="col-6">
					<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
					</div> -->
					<div class="col">
					<button type="button" class="close" @click="$emit('closeModal')">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
				</div>

				<div class="modal-body">
					<h2 class="title">Print Kwitansi</h2>
					<div v-if="page == 1">
					<div>
						<h5>Print Tanda Terima Dokumen</h5>
						<div class="row row-space mt-2">
						<div class="col-1">
							<input type="checkbox" v-model="printTTD" style="width: 50px">
							
						</div>
						<div class="col-5">
							<label for="biaya">
							Print Tanda Terima Dokumen
							</label>
						</div>
						</div>

						<div v-if="printTTD" class="border border-secondary p-10">
						<div class=" text-left">
							<button class="btn btn-primary mr-3" style="width: 120px;" @click="tandaTerima.push(Object.assign({} , modelDokumen))">+ Dokumen</button>
							<button class="btn btn-danger mr-3" style="width: 120px;" :disabled="tandaTerima.length <= 11" @click="tandaTerima.pop()">- Dokumen</button>
						</div>
						<br>
						<div class="row ">
							<!-- 
							-->
							<div class="col-2 text-center">
							<label >Ada</label>
							</div>
							<div class="col-2 text-center">
							<label >Tidak Ada</label> 
							</div>
							<div class="col-5">
							<label >Nama Dokumen</label> 
							</div>
						</div>
						<div v-for="(dokumen, index) in tandaTerima" :key="index" style="font-weight:bold" class="row text-center">
							<div class="col-2 pt-2">
							<input type="radio" :id="'selectDokumen'+index" v-model="dokumen.value" :value="true" >
							</div>
							<div class="col-2 pt-2">
							<input type="radio" :id="'selectDokumen'+index" v-model="dokumen.value" :value="false">
							</div>
							<div class="col-5">
							<input type="text" :disabled="index < 11" v-model="dokumen.name" :id="'selectDokumen' + index" style="border-bottom:1px solid black" placeholder="Tulis Nama Dokumen Disini"/>
							</div>
							
							
							<!-- <label :for="'selectBank'+index">
							{{dokumen.name}}
							</label> -->
							
						</div>
						</div>
					</div>

					<div class="row mt-3" v-if="raw_data && raw_data.bank_account.length > 0">
						<div class="col-md-6">
						<h5>Pilih Bank Tujuan:</h5>
						<div v-for="(bank, index) in raw_data.bank_account">
							<input type="radio" :id="'selectBank'+index" v-model="selected_bank_index" :value="index" style="width: 50px">
							<label :for="'selectBank'+index">
							{{ bank.bank_account_name }}; {{ bank.bank_name }}; {{ bank.bank_account }}
							</label>
						</div>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-12 text-center">
							<button class="btn btn-info mr-3" style="width: 100px;" @click="nextPage()">Next Page</button>
							<button class="btn btn-danger" style="width: 100px;" @click="$emit('closeModal')">Keluar</button>
						</div>
					</div>

					</div>
					<div v-if="page == 2">
					<div class="row mb-3">
						<div class="col-12 text-center">
							<button class="btn btn-warning mr-3" style="width: 100px;" @click="page--">Back Page</button>
							<button class="btn btn-info mr-3" style="width: 125px;" v-if="paymentType == 'Full'" @click="printPage('kwitansiInvoice')">Print Kwitansi</button>
							<button class="btn btn-info mr-3" style="width: 125px;" v-else @click="printPage('kwitansiA5')">Print Kwitansi</button>
							<!-- <button class="btn btn-info mr-3" style="width: 125px;" @click="createPDF" v-if="printTTD">Save PDF Tanda Terima</button> -->
							<!-- <button class="btn btn-info mr-3" style="width: 125px;" @click="testFunction">Open Button</button> -->
							<button class="btn btn-info mr-3" style="width: 125px;" @click="printPage('ttd')" v-if="printTTD">Print Tanda Terima</button>
							<button class="btn btn-danger" style="width: 100px;" @click="$emit('closeModal')">Keluar</button>
						</div>
					</div>
					<div style="border: 1px solid black">
							<div  class="bodyKwitansi" id="printKwitansi" v-if="printTTD">
							<div  class="ml-3 mr-3 mt-3 border border-secondary pl-3 pr-3">
								<h3 class="text-center mb-2 mt-2" style="text-decoration:underline">Tanda Terima Dokumen</h3>
								<!-- {{woDetail}} -->
								<h4 class="mt-2">Kepada YTH : {{insuranceCompany ? insuranceCompany.name : woDetail.customer}}</h4>
								<table class="table table-borderless text-center">
								<tbody>
									<tr>
									<td>No. Polis</td>
									<td>:</td>
									<td>{{insuranceDetails ? insuranceDetails.policy_number : '-'}}</td>
									</tr>
									<tr>
									<td>No. Polisi</td>
									<td>:</td>
									<td>{{woDetail.nomor_polisi}}</td>
									<td>No. Work Order</td>
									<td>:</td>
									<td>{{form_code}}</td>
									</tr>
									<tr>
									<td>Kendaraan</td>
									<td>:</td>
									<td>{{woDetail.tipe}}</td>
									</tr>
								</tbody>
								</table>

								<table class="table table-bordered text-center">
								<thead>
									<th>No.</th>
									<th>Nama Dokumen</th>
									<th>Ada</th>
									<th>Tidak Ada</th>
								</thead>
								<tbody v-for="(dokumen, index) in tandaTerima" :key="index">
									<td>{{index + 1}}.</td>
									<td>{{dokumen.name}}</td>
									<td>{{dokumen.value == true ? 'V' : ''}}</td>
									<td>{{typeof dokumen.value == 'boolean' && dokumen.value == false ? 'V' : ''}}</td>
								</tbody>
								</table>

								<div class="mt-3">
								<h6>Jakarta , {{moment().format('DD MMMM YYYY')}}</h6>

								<div class="row mt-3">
									<div class="col-6 text-center"> 
									<h6>Yang Menyerahkan</h6>
									<h6 style="margin-top:80px">
										______________________
									</h6>
									</div>
									<div class="col-6 text-center"> 
									<h6>Yang Menerima</h6>
									<h6 style="margin-top:80px">
										______________________
									</h6>
									</div>
								</div>
								</div>
							</div>
							</div>

						
						<hr>
						
						<!-- PRINT WO START -->
						<div id="printMe" class="bodyKwitansi">
						<print-header v-if="paymentType == 'Full'"></print-header>  

						<div class="text-right w-100 pr-4">
							<p>No Kwitansi # :&nbsp; {{paymentType == 'Full' ? 'T' : 'OR'}}{{counter}}</p>
							<p>Work Order # : {{form_code}}</p>
						</div>

						<div class="ml-3 mr-3">
							<h3 class="text-center mb-3 mt-2">I N V O I C E</h3>
							<h5 class="col-12">Untuk Pembayaran : {{paymentType.split(/(?=[A-Z])/).join(' ')}}</h5>

							<table class="table table-borderless ml-2 mr-2" style="font-weight:bold;font-size:12px;width:99%">
							<tbody>
								<tr>
								<td>Kepada Yth</td>
								<td>:</td>
								<td>{{woDetail.pelanggan}}</td>
								
								<td>No Polisi</td>
								<td>:</td>
								<td>{{woDetail.nomor_polisi}}</td>
								</tr>
								<tr>
								<td>Alamat</td>
								<td>:</td>
								<td>{{woDetail.address}}</td>
								<td>Kendaraan</td>
								<td>:</td>
								<td>{{woDetail.tipe}}</td>
								</tr>
								<tr>
								<td>Asuransi</td>
								<td>:</td>
								<td>{{insuranceCompany ? insuranceCompany.name : '-'}}</td>
								<td>No Polis</td>
								<td>:</td>
								<td v-if="insuranceDetails">{{insuranceDetails.policy_number}}</td>
								</tr>
								<tr>
								<td>Up</td>
								<td>:</td>
								<td></td>
								<td>Warna / Th</td>
								<td>:</td>
								<td>{{woDetail.warna}} {{woDetail.year}}</td>
								</tr>
							</tbody>
							</table>
							<template v-if="paymentType == 'Full'">
							<div>
							<div class="w-100 mr-2 ml-2">
							<h6>Perincian Perbaikan Mobil</h6>
							<table class="table pl-2 pr-2 text-center" style="width:99%;margin-top:0px">
								<thead>
								<th>No.</th>
								<th>Keterangan</th>
								<th>Jumlah</th>
								<th>Harga</th>
								</thead>
								<tbody v-for="(estimation, index) in data.estimations.filter(x => x.is_approved_by_insurance)" :key="estimation.id">
								<tr >
									<td>{{index + 1}}</td>
									<td>{{estimation.sparepart_name}}</td>
									<td>{{estimation.amount}}</td>
									<td>Rp {{numberWithCommas(estimation.price_per_item * estimation.amount)}}</td>
								</tr>
								</tbody>
							</table>
							
							</div>

							<div class="w-100 mr-2 ml-2 mb-3" v-if="extraCost.length >= 1">
							<h6>Biaya Lain Lainnya</h6>
							<!-- {{extraCost}} -->
							<table class="table pl-2 pr-2 text-center" style="width:99%">
								<thead>
								<th>No.</th>
								<th>Deskripsi</th>
								<th>Harga</th>
								</thead>
								<tbody v-for="(cost, index) in extraCost" :key="index">
								<tr>
									<td>{{index + 1}}.</td>
									<td>{{cost.description}}</td>
									<td>Rp {{numberWithCommas(cost.amount)}}.-</td>
								</tr>
								</tbody>
							</table>
							</div>

						

							<div class="w-100 row row-space mr-2 ml-3 rowStyle">
							<h6 class="ml-2">Perincian Harga</h6>
					
							<div class="row mt-2 col-12">
								<div class="col-3">
								<h6>Total Part :</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(totalPart.toFixed(0))}}</h6>
								</div>
								<div class="col-3">
								<h6>Total Jasa :</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(totalJasa.toFixed(0))}}</h6>
								</div>
							</div>

							<div class="row mt-2 col-12">
								<div class="col-3">
								<h6>Total Derek :</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(data.details.derek)}}</h6>
								</div>
								<div class="col-3">
								<h6>Total Own Risk :</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(data.details.own_risk)}}</h6>
								</div>
							</div>

							<div class="row mt-2 col-12">
								<div class="col-3">
								<h6>Total Discount :</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(parseFloat(data.details.discount) + parseFloat(data.details.discount_part))}}</h6>
								</div>
								<div class="col-3">
								<h6>Total PPN:</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(ppn)}}</h6>
								</div>
							</div>

							<div class="row mt-2 col-12">
								<div class="col-3">
								<h6>PPh 23</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(data.details.pph)}}</h6>
								</div>
								<div class="col-3" v-if="extraCost.length >= 1">
								<h6>Biaya Lain Lainnya:</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(sum(extraCost , 'amount'))}}</h6>
								</div>
							</div>
							<div class="row mt-2 col-12" v-if="dp">
								<div class="col-3">
								<h6>Down Payment</h6>
								</div>
								<div class="col-3">
								<h6>Rp. {{numberWithCommas(dp)}}</h6>
								</div>
							</div>
							</div>

							<h5 class="pl-3 mt-3 ml-1">Net Total : Rp {{total}} (## {{Math.abs(total.split(',').join('')) | terbilang}} Rupiah ##)</h5>
							</div>
							</template>
							<template v-else>
							<div class="mt-2 row row-space ml-2" v-if="paymentType == 'OwnRisk'">
								<h5 class="col-12 pl-2 mt-3 ml-1">Net Total : Rp {{total}} (## {{ Math.abs(total.split(',').join('')) | terbilang }} Rupiah ##)</h5>
							</div>
							<div class="mt-2 row row-space ml-2" v-else>
								
								<h5 class="col-12 pl-2 mt-3 ml-1">Net Total : Rp {{totalCost}} ## {{totalCost.split(',').join('') | terbilang}} Rupiah ##</h5>
							</div>
							</template>

							<div v-if="raw_data" class="mt-3 pl-3 ml-1 rowStyle">
							<div class="row">
								<div class="col-8">
								<p style="font-size:15px;">Saran dan Kritik SMS ke No. {{raw_data.ketik_saran_number}}</p>
								<template v-if="selected_bank">
									<p style="font-size:15px;">Pembayaran bisa ditransfer melewati akun bank kami :</p>
		
									<h5>{{ selected_bank.bank_account_name }}</h5>
									
									<h5>{{ selected_bank.bank_name }}</h5>
									<br>
									<h5>Account No. : {{ selected_bank.bank_account }}</h5>
									<br>
								</template>
								<!-- <p>Bank Central Asia TBK. - Cab. Graha Kirana</p> -->

								</div>
								<div class="col-4">
								<br>
								<br>
								<br>
								<p style="font-size:15px;">Jakarta , {{moment().format('DD MMMM YYYY')}}</p>
								</div>
							</div>
							
							</div>
						</div>
						<iframe id="iFramePdf" :src="srcData" style="display:none;"></iframe>
						
						</div>
						<!-- PRINT WO END -->
					</div>

					</div>
					
				</div>
			</div>
			</div>
		</div>
		<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
		</div>
	</div>
	</transition>
</template>

<script>
import printHeader from '@/components/print/print_header.vue'
import MultiSelect from 'vue-multiselect';
import Terbilang from 'terbilang-js'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import env from '@/env'
import printJS from 'print-js'


export default {
	data () {
		return {
			counter : null,
			estimationJasa : [],
			estimationPart : [],
			estimationBahan : [],
			moment: moment,
			raw_data : null,
			selected_bank : null,
			selected_bank_index : null,
			tandaTerima : [{
				name : 'Kwitansi Asli',
				value : null
				},{
				name : 'Surat Puas',
				value : null
				},{
				name : 'Faktur Pajak',
				value : null
				},{
				name : 'Foto Epoxy',
				value : null
				},{
				name : 'Foto Kerusakan',
				value : null
				},{
				name : 'Foto Selesai',
				value : null
				},{
				name : 'Salvage',
				value : null
				},{
				name : 'Copy SPK',
				value : null
				},{
				name : 'Copy LKKP',
				value : null
				},{
				name : 'Copy STNK',
				value : null
				},{
				name : 'Esek Esek',
				value : null
			}],
			modelDokumen : {
				name : '',
				value : null
			},
			printTTD : false,
			page : 1,
			srcData : null,
			reason : null,
			printing : false
		}
	},
	props : [
		'form_code',
		'data',
		'woDetail' ,
		'insuranceDetails',
		'discount',
		'total',
		'insuranceCompany',
		'totalJasa',
		'totalPart',
		'totalSpecialBahan',
		'paymentType',
		'totalCost',
		'extraCost',
		'ppn',
		'dp',
		'tpl'
		
	],
	components:{
		MultiSelect,
		printHeader,
		VueHtml2pdf
	},
	mounted () {
		// this.splitEstimations()
		this.getCompanyProfile()
		this.getKwitansiCounter()
	},
	watch : {
		selected_bank_index () {
			this.selected_bank = this.raw_data.bank_account[this.selected_bank_index];
		},
	},
	methods : {
		getKwitansiCounter() {
			let urlString = this.paymentType == 'Full' ? 'T' : 'OR'
			this.$http.get(`/api/v1/workorder/print/getUniqueCounter?type=${urlString}&workorder=${this.form_code}`)
			.then((resp) => {
				this.counter = resp.data.data.nextCounter
				
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		testFunction () {
			window.open('/testInvoice.txt').print()
			// window.open('/invoice.docx').print()
			// window.open('/invoice.rtf').print()
		},
		createPDF() {
			this.$refs.html2Pdf.generatePdf()
		},
		nextPage() {
			if(this.printTTD) {
				for(var i =0  ; i < this.tandaTerima.length ; i++) {
					// console.log(typeof this.tandaTerima[i].value ,this.tandaTerima[i].value)
					if(this.tandaTerima[i].name == '') {
						this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Nama Dokumen Terlebih Dahulu'])
						return;
					}
					if(typeof this.tandaTerima[i].value == 'object' && this.tandaTerima[i].value == null) {
						this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Semua Ketersediaan Dokumen'])
						return;
					}
				}
			}
			this.page++;
		},
		getCompanyProfile() {
			this.$http.get('/api/v1/company_profile')
			.then((resp)=>{
				this.raw_data = resp.data.data;

				if (resp.data.data.bank_account.length > 0) {
					this.selected_bank = resp.data.data.bank_account[0]
					this.selected_bank_index = 0;
				}
			})
			.catch((err)=>{console.log(err);})
		},
		printPage(type){

			if(this.printing) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Ditunggu Process Print Lagi Berlangsung'])
				return
			}
			this.printing = true
				

		
			let styles = {
				name: '_blank',
				specs: [
					'fullscreen=yes',
					'titlebar=yes',
					'scrollbars=yes'
				],
				styles : [
					'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
					'https://unpkg.com/kidlat-css/css/kidlat.css',
					'/custom.css'
				]
			}
			

			if(type == 'ttd') {
			// this.$htmlToPaper('printKwitansi', styles , () => {
			//   console.log('Done')
			// })
				this.$http({
				url : '/api/v1/workorder/print/printDoc',
				method : 'post',
				data : {
					type : 'printTT',
					data : {
						form_code : this.form_code , 
						customer_name : this.woDetail.pelanggan,
						car_name : this.woDetail.tipe,
						registration :  this.woDetail.nomor_polisi,
						insurance_name : this.insuranceCompany ? this.insuranceCompany.name : '-',
						insurance_policy : this.insuranceDetails ? this.insuranceDetails.policy_number : '-',
						tanda_terima : this.tandaTerima
					}
				}
				})
				.then((resp) => {
					let data = resp.data.data
					console.log(data)
					var prntWin = window.open("");
					prntWin.document.write("<html><head><title>"+name+"</title></head><body>" + 
					'<iframe width="100%" height="100%" name="plugin" src="'+env.baseImage + '/' + data+'"></iframe></body></html>');

					// prntWin.print();
					this.printing = false

					
				})
				.catch((err) => {
					console.log(err)
					this.printing = false
				})
			}
			else if (type == 'kwitansiInvoice') {
				let real_amount = Math.abs(parseFloat(this.total.split(',').join('')) + parseFloat(this.dp ? this.dp : 0));
				console.log(real_amount)
				this.$http({
					url : '/api/v1/workorder/print/printDoc',
					method : 'post',
					data : {
						type : 'printInvoice',
						data : {
							form_code : this.form_code,
							invoice_no : 'T' + this.counter,
							amount : this.total,
							real_amount : this.numberWithCommas(real_amount),
							real_amount_text : this.terbilang(real_amount),
							amount_text : this.terbilang(Math.abs(this.total.split(',').join(''))),
							customer_name : this.woDetail.pelanggan,
							car_brand : this.woDetail.tipe,
							registration : this.woDetail.nomor_polisi,
							policy_no : this.insuranceDetails ? this.insuranceDetails.policy_number : '-',
							year : this.woDetail.tahun,
							insurance : this.insuranceCompany ? this.insuranceCompany.name : '-',
							totalJasa : this.numberWithCommas(this.totalJasa.toFixed(0)),
							totalPart : this.numberWithCommas(this.totalPart.toFixed(0)),
							totalSpecialBahan : this.numberWithCommas(this.totalSpecialBahan.toFixed(0)),
							tpl : this.tpl,
							bll : this.numberWithCommas(this.sum(this.extraCost , 'amount')),
							dp : this.dp ? this.numberWithCommas(this.dp) : 0,
							pph : this.data.details.pph ? this.numberWithCommas(this.data.details.pph) : 0,
							discount : this.numberWithCommas(parseFloat(this.data.details.discount) + parseFloat(this.data.details.discount_part)),
							derek : this.data.details.derek,
							or : this.numberWithCommas(this.data.details.own_risk),
							ppn : this.numberWithCommas(this.ppn),
							bank_name : this.selected_bank.bank_name,
							bank_account : this.selected_bank.bank_account,
							bank_account_name : this.selected_bank.bank_account_name,
							payment_type : this.insuranceCompany ? 'Perbaikan Kendaraan' : 'Beli Sparepart',
							count_sparepart : this.data.estimations.filter(x => x.sparepart_type == 'P').length
						}
					}
				})
				.then((resp) => {
					let data = resp.data.data
					console.log(data)
					var prntWin = window.open("");
					prntWin.document.write("<html><head><title>"+name+"</title></head><body>" + 
					'<iframe width="100%" height="100%" name="plugin" src="'+env.baseImage + '/' + data+'"></iframe></body></html>');
					this.reason = null

					// prntWin.print();
					this.getKwitansiCounter()
					this.printing = false

				})

				.catch((err) => {
					console.log(err)
					this.printing = false
				})
			}
			else if (type == 'kwitansiA5') {
				this.$http({
					url : '/api/v1/workorder/print/printDoc',
					method : 'post',
					data : {
						type : 'printOR',
						data : {
								form_code : this.form_code , 
								customer_name : this.woDetail.pelanggan,
								amount_text : '## ' + this.terbilang(this.totalCost.split(',').join('')) + ' ##',
								car_name : this.woDetail.tipe,
								tpl : this.tpl,
								registration :  this.woDetail.nomor_polisi,
								insurance_name : this.insuranceCompany.name,
								insurance_policy : this.insuranceDetails ? this.insuranceDetails.policy_number : '-',
								amount : this.totalCost,
								bank : {
								name : this.selected_bank.bank_account_name,
								bank_name : this.selected_bank.bank_name,
								account_no : this.selected_bank.bank_account,
								reason : this.reason
							}
						}
					}
				})
				.then((resp) => {
					let data = resp.data.data
					console.log(data)
					var prntWin = window.open("");
					prntWin.document.write("<html><head><title>"+name+"</title></head><body>" + 
					'<iframe width="100%" height="100%" name="plugin" src="'+env.baseImage + '/' + data+'"></iframe></body></html>');
					this.reason = null

					// prntWin.print();
					this.getKwitansiCounter()
					this.printing = false

					
				})
				.catch((err) => {
					console.log(err)
					this.printing = false
				})
			}
			else {
				this.$htmlToPaper('printMe' , () => {
					console.log("Done")
				})

				this.$http.post('/api/v1/workorder/print/saveCounter' , {
					form_code : this.form_code,
					unique_code : (this.paymentType == 'Full' ? 'T' : 'OR') + this.counter,
					reason : this.reason
				})
				.then((resp) => {
					this.reason = null
					this.getKwitansiCounter()
					this.printing = false
					
				})
				.catch((err)=> {
					console.log(err)
					this.printing = false
				})
			}
			
			

			

			let url = '/api/v1/workorder-estimation/'+ this.form_code  + '/receipt'

			this.paymentType  == 'Full' ? url += '?insert=1': ''

			this.$http.get(url)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Print Kwitansi Tercatat'])
			})
			.catch((err) => {
				console.log(err)
				let array = err.response.data.data.details.map(x => x.message)
				this.$store.dispatch('triggerAlert' , [false , array])
			})
		},
		terbilang (value) {
			function terbilang(a){var c=" Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas".split(" ");if(12>a)var b=c[a];else 20>a?b=c[a-10]+" Belas":100>a?(b=parseInt(String(a/10).substr(0,1)),b=c[b]+" Puluh "+c[a%10]):200>a?b="Seratus "+terbilang(a-100):1E3>a?(b=parseInt(String(a/100).substr(0,1)),b=c[b]+" Ratus "+terbilang(a%100)):2E3>a?b="Seribu "+terbilang(a-1E3):1E4>a?(b=parseInt(String(a/1E3).substr(0,1)),b=c[b]+" Ribu "+terbilang(a%1E3)):1E5>a?(b=parseInt(String(a/100).substr(0,2)),
			a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E6>a?(b=parseInt(String(a/1E3).substr(0,3)),a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E8>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E9>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E10>a?(b=parseInt(String(a/1E9).substr(0,1)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E11>a?(b=parseInt(String(a/1E9).substr(0,2)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):
			1E12>a?(b=parseInt(String(a/1E9).substr(0,3)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E13>a?(b=parseInt(String(a/1E10).substr(0,1)),a%=1E10,b=terbilang(b)+" Triliun "+terbilang(a)):1E14>a?(b=parseInt(String(a/1E12).substr(0,2)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E15>a?(b=parseInt(String(a/1E12).substr(0,3)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E16>a&&(b=parseInt(String(a/1E15).substr(0,1)),a%=1E15,b=terbilang(b)+" Kuadriliun "+terbilang(a));a=b.split(" ");c=[];for(b=0;b<a.length;b++)""!=a[b]&&c.push(a[b]);return c.join(" ")};
			return terbilang(value);
		},
		sum(arr , variable) {
			let newArr = arr.map(x => x[variable])
			let total = 0
			for(var i = 0 ; i < newArr.length ; i++) {
				total+= parseFloat(newArr[i])
				arr[variable] = parseFloat(arr[variable])
			}

			return total
		},
		evaluateDamage(figure){
			var damages = ""
			for(var i in figure){
				for(var j in figure[i]){
					if(figure[i][j]) damages += `${this.toCapitalizedWords(j)}, `
				}
			}

			return damages ? damages.substring(0, damages.length-2) : '-'
		},
	}
}
</script>

<style scoped>
* {
	font-family: Verdana, Geneva, Tahoma, sans-serif;
}
p {
	font-size: 15px;
}

td {
	font-size: 12px;
}

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding:20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
	#TITLE made by Colorlib (https://colorlib.com)
	========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
	}


.companyDetails{
	margin-bottom: 5px;
	font-size:.6rem;
}
/* .documentTitle{
font-size: 40px;
border: 1px solid black;
border-radius: 10px;
padding:20px 30px;
} */
.contentTitle{
	margin-top:8px;
	font-size:14px;
	font-weight: 700;
}
.contentvalue{
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
}

</style>